import { ProductCategoryItem } from 'components/shared/ProductAndClientSelector/ProductCategoryItem';
import type { ProductVariation } from 'models/productsReferential';
import { FC, useEffect } from 'react';
import { useGetAssetTypesOptions } from 'routes/essential-workspace/components/product-selector/hooks/use-assets-types';

export type AssetSelectorProps = {
  products: readonly ProductVariation[];
  selectedAssetType?: string;
  onSelectAssetType: (assetType: string) => void;
};

export const AssetSelector: FC<AssetSelectorProps> = ({ products, selectedAssetType, onSelectAssetType }) => {
  const availableAssetTypeFilters = useGetAssetTypesOptions(products);

  useEffect(() => {
    if (!selectedAssetType && availableAssetTypeFilters.length > 0) {
      onSelectAssetType(availableAssetTypeFilters[0].value);
    }
  }, [selectedAssetType, availableAssetTypeFilters, onSelectAssetType]);

  return (
    <ul className="col-3 h-100 p-0 border-end overflow-y-auto scrollbar-sm list-unstyled mb-0" aria-label="Asset types">
      {availableAssetTypeFilters.map(({ value, label, icon }) => (
        <li key={value}>
          <ProductCategoryItem
            className="ps-1 pe-0"
            isItemSelected={selectedAssetType === value}
            onItemClick={() => onSelectAssetType(value)}
          >
            <div className="d-flex gap-2">
              <span className="icon icon-sm text-muted mx-2" aria-hidden="true">
                {icon}
              </span>
              <span className="text-wrap text-start">{label}</span>
            </div>
            <span className="icon icon-sm text-muted mx-2" aria-hidden="true">
              keyboard_arrow_right
            </span>
          </ProductCategoryItem>
        </li>
      ))}
    </ul>
  );
};
